import { filter_day, filter_month, filter_week } from '../../../../../views/marketing/overview/PeriodFilter';

export default {
  filters: {
    [filter_day]: 'Día',
    [filter_week]: 'Semana',
    [filter_month]: 'Mes',
    null: 'Total',
  },
};
